import {
  ADD_BOX_FAIL,
  ADD_BOX_REQUEST,
  ADD_BOX_SUCCESS,
  CLEAR_FILE_TYPE,
  CLEAR_PENDING_QUOTE_ATTACHMENT,
  CLOSE_SIDEBAR,
  FAILED_STATE_COUNTRY_DATA,
  FAILED_UI_RULES,
  GET_FILE_TYPE,
  GET_PENDING_QUOTE_ATTACHMENT,
  LOADING_STATE_COUNTRY_DATA,
  OPEN_SIDEBAR,
  REQUEST_UI_RULES,
  SELECTED_ATTACHMENT_INFO_CLOSE,
  SELECTED_ATTACHMENT_INFO_OPEN,
  SELECTED_DATE_SUCCESS,
  SELECTED_ORDER_TYPE_SUCCESS,
  SELECTED_TAB_SUCCESS,
  SELECT_DROPDOWN_CLOSE,
  SELECT_DROPDOWN_OPEN,
  SET_FILE_TYPE,
  SET_PENDING_QUOTE_ATTACHMENT,
  SET_WIDGETS,
  SUCCESS_STATE_COUNTRY_DATA,
  SUCCESS_UI_RULES,
  TABLE_DROPDOWN_CLOSE,
  TABLE_DROPDOWN_OPEN,
  TOGGLE_WIDGET
} from '@/constants/uiConstants'

const addBoxInitial_val = {
  top: 0,
  left: 0,
  isOpened: false,
  text: ''
}

// Widget defaults are now resolved from UI rules + user rules at runtime and
// dispatched via SET_WIDGETS (see resolveDashboardWidgets + Header.jsx).
// Keep this empty so nothing renders before hydration.
const initialState = {
  widgets: {}
}

export const AddBoxReducer = (state = { addBoxDetails: addBoxInitial_val }, action) => {
  switch (action.type) {
    case ADD_BOX_REQUEST:
      return { loading: true, addBoxDetails: {} }
    case ADD_BOX_SUCCESS:
      return {
        loading: false,
        addBoxDetails: action.payload
      }
    case ADD_BOX_FAIL:
      return { loading: false, error: action.error }
    default:
      return state
  }
}

export const tabelDropdownStateReducer = (state = { isOpened: false }, action) => {
  switch (action.type) {
    case TABLE_DROPDOWN_OPEN:
      return { isOpened: true }
    case TABLE_DROPDOWN_CLOSE:
      return { isOpened: false }
    default:
      return state
  }
}

export const selectDropdownStateReducer = (state = { isOpened: false }, action) => {
  switch (action.type) {
    case SELECT_DROPDOWN_OPEN:
      return { isOpened: true }
    case SELECT_DROPDOWN_CLOSE:
      return { isOpened: false }
    default:
      return state
  }
}

export const selectAttachmentInfoStateReducer = (state = { isOpened: false, title: '' }, action) => {
  switch (action.type) {
    case SELECTED_ATTACHMENT_INFO_OPEN:
      return { isOpened: true, title: action.payload?.title }
    case SELECTED_ATTACHMENT_INFO_CLOSE:
      return { isOpened: false, title: undefined }
    default:
      return state
  }
}

export const selectedTabReducer = (state = { selectedTab: 'mail' }, action) => {
  switch (action.type) {
    case SELECTED_TAB_SUCCESS:
      return { selectedTab: action.payload }
    default:
      return state
  }
}

export const selectedorderTypeReducer = (state = { selectedType: 'pending' }, action) => {
  switch (action.type) {
    case SELECTED_ORDER_TYPE_SUCCESS:
      return { selectedType: action.payload }
    default:
      return state
  }
}

export const selectedDateReducer = (state = { selectedDate: 'All', selectedDateVal: null }, action) => {
  switch (action.type) {
    case SELECTED_DATE_SUCCESS:
      return {
        selectedDate: action.payload,
        selectedDateVal: action.selectedDateVal
      }
    default:
      return state
  }
}

export const stateCountryDropdownListReducer = (
  state = {
    loading: false,
    country: [],
    state: [],
    city: [],
    active: false,
    error: null
  },
  action
) => {
  switch (action.type) {
    case LOADING_STATE_COUNTRY_DATA:
      return {
        ...state,
        loading: true,
        active: false,
        error: null
      }
    case SUCCESS_STATE_COUNTRY_DATA:
      return {
        ...state,
        ...action.payload,
        loading: false,
        active: true
      }
    case FAILED_STATE_COUNTRY_DATA:
      return {
        ...state,
        loading: false,
        active: false,
        error: action.payload
      }
    default:
      return state
  }
}

export const UiRulesReducer = (
  state = {
    loading: false,
    rules: {},
    error: null
  },
  action
) => {
  switch (action.type) {
    case REQUEST_UI_RULES:
      return {
        loading: true,
        active: false,
        error: null
      }
    case SUCCESS_UI_RULES:
      return {
        rules: action.payload,
        loading: false,
        active: true
      }
    case FAILED_UI_RULES:
      return {
        loading: false,
        error: action.payload
      }
    default:
      return state
  }
}

export const toggleSidebarReducer = (state = { toggle: false }, action) => {
  switch (action.type) {
    case OPEN_SIDEBAR:
      return { toggle: true }
    case CLOSE_SIDEBAR:
      return { toggle: false }
    default:
      return state
  }
}

export const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_WIDGET:
      return {
        ...state,
        widgets: {
          ...state.widgets,
          [action.payload]: !state.widgets[action.payload]
        }
      }
    case SET_WIDGETS:
      return {
        ...state,
        widgets: { ...action.payload }
      }
    default:
      return state
  }
}

// Pending Quote Attachment Reducer - replaces sessionStorage for real-time sync
export const pendingQuoteAttachmentReducer = (
  state = {
    pendingAttachment: null,
    timestamp: null,
    isActive: false
  },
  action
) => {
  switch (action.type) {
    case SET_PENDING_QUOTE_ATTACHMENT:
      return {
        pendingAttachment: action.payload,
        timestamp: Date.now(),
        isActive: true
      }
    case CLEAR_PENDING_QUOTE_ATTACHMENT:
      return {
        pendingAttachment: null,
        timestamp: null,
        isActive: false
      }
    case GET_PENDING_QUOTE_ATTACHMENT:
      // This action type is for reading only, doesn't change state
      return state
    default:
      return state
  }
}

const fileTypeReducerinitialState = {
  fileType: 'email'
}

export const fileTypeReducer = (state = fileTypeReducerinitialState, action) => {
  switch (action.type) {
    case GET_FILE_TYPE:
      return state

    case SET_FILE_TYPE:
      return {
        ...state,
        fileType: action.payload
      }

    case CLEAR_FILE_TYPE:
      return {
        ...state,
        fileType: 'email'
      }

    default:
      return state
  }
}
